import React, {useEffect, useState} from "react";
import usePortalService from "../../services/PortalService";
import { useParams } from 'react-router-dom';
import { AdminNavbar, ManagerNavbar } from "../../Components/Navbars";
import { Reaction } from "./Reaction";
import { Reaction as ReactionType } from "../../types";

let reactionId: string;
export const ReactionForAdmin = () => {
  const {getReactionById} = usePortalService();

  const params = useParams();
  reactionId = params.id as string;

  const [isBottom, setIsBottom] = useState<boolean | null>(false)
  
  const [reaction, setReaction] = useState<ReactionType>();

  const [queryError, setQueryError] = useState('');

  const handleScroll = () => {
    const element = document.getElementById("main");
    setIsBottom(element && element.getBoundingClientRect().bottom - window.innerHeight <= 30)
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("resize", () => handleScroll());

    (
      async () => {
        getReactionById(reactionId).then(result => {
          if (result.success) {
            setReaction(result.reaction);
            setQueryError('');
          }
          else {
            setQueryError(result.errors);
          }
        })
      }
    )()
  },[])

  return(
    <>
      <AdminNavbar />
      {(queryError) ? 
        <p className="error-alert">{queryError}</p> :
        <Reaction reaction={reaction}/>}
    </>
  )
}